import { render, staticRenderFns } from "./pwa-app.vue?vue&type=template&id=213f8284&"
import script from "./pwa-app.vue?vue&type=script&lang=js&"
export * from "./pwa-app.vue?vue&type=script&lang=js&"
import style0 from "./pwa-app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports